import { registerApp, getWindow } from '../../utils.js';

const appId = 'e2etestguest';
let host = null;
let loanObj = null;
let inventoryObj = null;
let subscriptions = [];

const browserWindow = getWindow(appId);
window.emui = window.emui || { uuid: crypto.randomUUID() };

const log = (msg, type = 'info') => {
  const el = document.getElementById('guestLog');
  if (!el) return;
  const ts = new Date().toLocaleTimeString();
  const color =
    type === 'error'
      ? '#dc2626'
      : type === 'success'
      ? '#16a34a'
      : type === 'warn'
      ? '#ca8a04'
      : '#374151';
  el.innerHTML += `<div style="color:${color}">[${ts}] ${msg}</div>`;
  el.scrollTop = el.scrollHeight;
};

const showResult = (data) => {
  const el = document.getElementById('resultPanel');
  if (el) el.textContent = JSON.stringify(data, null, 2);
};

const createUI = () => {
  document.body.innerHTML = `
    <div style="font-family:system-ui;font-size:13px;padding:8px;">
      <h3 style="margin:0 0 8px;font-size:14px;color:#4338ca;">E2E Test Guest</h3>

      <div style="margin-bottom:8px;">
        <strong>Scripting Object Access</strong><br/>
        <button id="btnGetLoan" data-testid="guest-get-loan"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">getObject("Loan")</button>
        <button id="btnGetInventory" data-testid="guest-get-inventory"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">getObject("Inventory")</button>
        <button id="btnGetMissing" data-testid="guest-get-missing"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">getObject("NonExistent")</button>
      </div>

      <div style="margin-bottom:8px;">
        <strong>Method Invocation</strong><br/>
        <button id="btnGetDetails" data-testid="guest-get-details"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Loan.getLoanDetails()</button>
        <button id="btnSetCredit" data-testid="guest-set-credit"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Loan.setCreditScore(800)</button>
        <button id="btnGetItems" data-testid="guest-get-items"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Inventory.getItems()</button>
      </div>

      <div style="margin-bottom:8px;">
        <strong>Event Subscription</strong><br/>
        <button id="btnSubPreSave" data-testid="guest-sub-presave"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Subscribe onPreSave</button>
        <button id="btnSubAmount" data-testid="guest-sub-amount"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Subscribe onLoanAmountChanged</button>
        <button id="btnUnsubAll" data-testid="guest-unsub-all"
          style="margin:2px;padding:2px 8px;font-size:12px;cursor:pointer;">Unsubscribe All</button>
      </div>

      <div style="margin-bottom:4px;"><strong>Result</strong></div>
      <pre id="resultPanel" data-testid="guest-result"
        style="background:#f3f4f6;padding:6px;border-radius:4px;min-height:40px;font-size:11px;white-space:pre-wrap;overflow:auto;max-height:120px;">Waiting...</pre>

      <div style="margin-bottom:4px;margin-top:6px;">
        <strong>Guest Log</strong>
        <button id="btnClearGuestLog" style="margin-left:8px;font-size:11px;cursor:pointer;">Clear</button>
      </div>
      <div id="guestLog" data-testid="guest-log"
        style="background:#f3f4f6;padding:6px;border-radius:4px;min-height:60px;max-height:120px;font-size:11px;overflow:auto;"></div>
    </div>
  `;
};

const wireButtons = () => {
  // --- getObject ---
  document.getElementById('btnGetLoan').addEventListener('click', async () => {
    try {
      loanObj = await host.getObject('Loan');
      if (loanObj) {
        log('getObject("Loan") → OK', 'success');
        showResult({
          status: 'found',
          objectId: 'Loan',
          methods: Object.keys(loanObj).filter(
            (k) => typeof loanObj[k] === 'function',
          ),
        });
      } else {
        log('getObject("Loan") → null (not registered)', 'warn');
        showResult({ status: 'null' });
      }
    } catch (e) {
      log(`getObject("Loan") failed: ${e.message}`, 'error');
      showResult({ error: e.message });
    }
  });

  document
    .getElementById('btnGetInventory')
    .addEventListener('click', async () => {
      try {
        inventoryObj = await host.getObject('Inventory');
        if (inventoryObj) {
          log('getObject("Inventory") → OK', 'success');
          showResult({
            status: 'found',
            objectId: 'Inventory',
            methods: Object.keys(inventoryObj).filter(
              (k) => typeof inventoryObj[k] === 'function',
            ),
          });
        } else {
          log('getObject("Inventory") → null (not registered)', 'warn');
          showResult({ status: 'null' });
        }
      } catch (e) {
        log(`getObject("Inventory") failed: ${e.message}`, 'error');
        showResult({ error: e.message });
      }
    });

  document
    .getElementById('btnGetMissing')
    .addEventListener('click', async () => {
      try {
        const obj = await host.getObject('NonExistent');
        if (obj) {
          log('getObject("NonExistent") → unexpectedly found', 'warn');
          showResult({ status: 'found (unexpected)' });
        } else {
          log('getObject("NonExistent") → null (expected)', 'success');
          showResult({ status: 'null', expected: true });
        }
      } catch (e) {
        log(`getObject("NonExistent") error: ${e.message}`, 'error');
        showResult({ error: e.message });
      }
    });

  // --- Method invocation ---
  document
    .getElementById('btnGetDetails')
    .addEventListener('click', async () => {
      if (!loanObj) {
        log('Loan not loaded — click getObject("Loan") first', 'warn');
        return;
      }
      try {
        const details = await loanObj.getLoanDetails();
        log('Loan.getLoanDetails() → OK', 'success');
        showResult(details);
      } catch (e) {
        log(`getLoanDetails() failed: ${e.message}`, 'error');
        showResult({ error: e.message });
      }
    });

  document
    .getElementById('btnSetCredit')
    .addEventListener('click', async () => {
      if (!loanObj) {
        log('Loan not loaded — click getObject("Loan") first', 'warn');
        return;
      }
      try {
        const result = await loanObj.setCreditScore(800);
        log('Loan.setCreditScore(800) → OK', 'success');
        showResult(result);
      } catch (e) {
        log(`setCreditScore() failed: ${e.message}`, 'error');
        showResult({ error: e.message });
      }
    });

  document.getElementById('btnGetItems').addEventListener('click', async () => {
    if (!inventoryObj) {
      log('Inventory not loaded — click getObject("Inventory") first', 'warn');
      return;
    }
    try {
      const items = await inventoryObj.getItems();
      log('Inventory.getItems() → OK', 'success');
      showResult(items);
    } catch (e) {
      log(`getItems() failed: ${e.message}`, 'error');
      showResult({ error: e.message });
    }
  });

  // --- Event subscription ---
  document
    .getElementById('btnSubPreSave')
    .addEventListener('click', async () => {
      if (!loanObj) {
        log('Loan not loaded — click getObject("Loan") first', 'warn');
        return;
      }
      try {
        const token = host.subscribe({
          eventId: loanObj.onPreSave.id,
          callback: ({ eventParams }) => {
            log(
              `EVENT onPreSave received: ${JSON.stringify(eventParams)}`,
              'success',
            );
            showResult({ event: 'onPreSave', eventParams });
            return true;
          },
        });
        subscriptions.push({ eventId: loanObj.onPreSave.id, token });
        log(`Subscribed to onPreSave (token=${token})`, 'success');
        showResult({ subscribed: 'onPreSave', token });
      } catch (e) {
        log(`Subscribe onPreSave failed: ${e.message}`, 'error');
      }
    });

  document
    .getElementById('btnSubAmount')
    .addEventListener('click', async () => {
      if (!loanObj) {
        log('Loan not loaded — click getObject("Loan") first', 'warn');
        return;
      }
      try {
        const token = host.subscribe({
          eventId: loanObj.onLoanAmountChanged.id,
          callback: ({ eventParams }) => {
            log(
              `EVENT onLoanAmountChanged received: ${JSON.stringify(
                eventParams,
              )}`,
              'success',
            );
            showResult({ event: 'onLoanAmountChanged', eventParams });
          },
        });
        subscriptions.push({ eventId: loanObj.onLoanAmountChanged.id, token });
        log(`Subscribed to onLoanAmountChanged (token=${token})`, 'success');
        showResult({ subscribed: 'onLoanAmountChanged', token });
      } catch (e) {
        log(`Subscribe onLoanAmountChanged failed: ${e.message}`, 'error');
      }
    });

  document.getElementById('btnUnsubAll').addEventListener('click', () => {
    subscriptions.forEach(({ eventId, token }) => {
      try {
        host.unsubscribe({ eventId, token });
      } catch (e) {
        /* ignore */
      }
    });
    log(`Unsubscribed ${subscriptions.length} listener(s)`, 'success');
    subscriptions = [];
    showResult({ unsubscribed: 'all' });
  });

  document.getElementById('btnClearGuestLog').addEventListener('click', () => {
    document.getElementById('guestLog').innerHTML = '';
  });
};

window.emui.app = {
  uuid: window.emui.uuid,
  init: async (options) => {
    host = options.host;
    return Promise.resolve();
  },
  mount: async () => {
    createUI();
    wireButtons();
    log('E2E Test Guest mounted', 'success');
    return Promise.resolve();
  },
  unmount: async () => {
    subscriptions = [];
    loanObj = null;
    inventoryObj = null;
    return Promise.resolve();
  },
};

registerApp({ browserWindow, appId, app: window.emui.app });
